module.exports = __webpack_public_path__ + "img/hometeacher-footer.216004a5.png";